// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
// Module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box;font-family:Roboto,sans-serif}#app{display:flex;align-items:center;justify-content:center;height:100vh;background:linear-gradient(90deg,#b4b5f8,#4fa8e3 50%,#29b9d6)}", ""]);
// Exports
module.exports = exports;
